import { hasNoValue } from '@app/util';
import { ValdrConstraints } from '@app/valdr/models/valdr-constraints';
import * as fromValdr from '@app/valdr/reducers/valdr';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import * as R from 'ramda';

interface ConstraintsForTypesProps {
  types: string[];
}

interface ValdrSelectors<T> {
  getValdrConstraints: MemoizedSelector<T, ValdrConstraints>;
  getConstraintsForTypes?: (props: ConstraintsForTypesProps) => MemoizedSelector<T, ValdrConstraints>;
}

/**
 * Creates selectors for valdr constraints.
 *
 * @template T
 * @param {MemoizedSelector} getValdrState - Selector that returns the valdr state
 * @return {ValdrSelectors} selectors for valdr constraints
 */
export const getValdrSelectors = <S>(getValdrState: MemoizedSelector<S, fromValdr.State>): ValdrSelectors<S> => {

  const getValdrConstraints = createSelector(
    getValdrState,
    fromValdr.getConstraints
  );

  const getConstraintsForTypes = (props: ConstraintsForTypesProps) =>
    createSelector(
      getValdrConstraints,
      (s): ValdrConstraints => hasNoValue(s) ? null : R.pick(props.types, s)
    );

  return {
    getValdrConstraints,
    getConstraintsForTypes
  };

};
